import React from "react";
import Footer from "../footer/Footer";
import Header from "../header/Header";
import VTDancePay from "../page/VTDancePay";

export default function LandingSellDance({page}) {
    return (
        <>
            <Header headerType="AdminDancePayOnly"/>
            <VTDancePay/>
            <Footer/>
        </>
    );
}